// Tema padrão do Meu Cupom.
// Cada token descreve um PAPEL visual (não uma cor). Os valores aqui são
// exatamente os que estavam hardcoded no código antes da criação dos temas,
// então o tema default não altera nada visualmente.
//
// Para criar um novo tema: copie o padrão de themes/blackFriday.js
// (spread do default + sobrescrita só do que muda) e registre em theme/index.js.

const defaultTheme = {
    name: 'default',
    colors: {
        // Barra de navegação, footer, áreas do perfil
        chrome: {
            headerBg: '#102051',
            headerText: '#ffffff',
            footerBg: '#102051',
            footerText: '#ffffff',
            mobileMenuBg: '#348AC7',
            drawerBg: '#2D3E50',
            perfilHeaderBg: '#0d1f51',
            perfilSidebarBg: '#233044',
            loginButtonBg: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
        },
        // Cores de marca usadas em títulos, blocos e realces
        brand: {
            primary: '#102051',
            deep: '#0A2342',
            deepAlt: '#0A1A3C',
            deepAltHover: '#122855',
            ink: '#1B1464',
            inkDark: '#0D0B5B',
            inkAlt: '#170C66',
            inkAltHover: '#2A2D7D',
            accent: '#348AC7',
            accentSoft: '#4196CB',
            accentSoftHover: '#3170a6',
            accentBright: '#4FA9E2',
            link: '#3599DB',
            linkHover: '#2b7fbf',
            linkTint: '#eaf2fd',
            cashback: '#0086CA',
        },
        // Banners / hero
        hero: {
            bg: '#4da6ff',
        },
        // Botões de ação principais
        cta: {
            bg: '#4196CB',
            tint: '#eaf4fb',
        },
        // Imagens de fundo (valor CSS completo: url(...))
        images: {
            // Fundo do header de lojas/categorias sem headerImage próprio
            headerBg: 'url(https://static.meucupom.com/media/Testes/44c9c8.jpg)',
            headerBgPosition: 'bottom',
            headerBgSize: 'cover',
        },
    },
};

export default defaultTheme;
